// @ts-nocheck
import { forwardRef } from 'react';
import PieChartWidget from './PieChartWidget';
import type { PieChartWidgetProps } from '../types';

/**
 * DonutChartWidget - Donut chart (convenience wrapper)
 *
 * A convenience wrapper around PieChartWidget that defaults to donut variant.
 */
const DonutChartWidget = forwardRef<HTMLDivElement, PieChartWidgetProps>(
  (props, ref) => {
    return (
      <PieChartWidget
        ref={ref}
        {...props}
        variant="donut"
      />
    );
  }
);

DonutChartWidget.displayName = 'DonutChartWidget';

export default DonutChartWidget;
